"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dispatchErrorToast = void 0;
const react_1 = __importDefault(require("react"));
const userSelector = (state) => { var _a; return (((_a = state === null || state === void 0 ? void 0 : state.user) === null || _a === void 0 ? void 0 : _a.loggedIn) ? state.user.account : null); };
const getErrorMap = (user, id, onCopy) => {
    return {
        500: {
            title: 'У нас технические проблемы',
            description: (react_1.default.createElement(react_1.default.Fragment, null,
                "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435 \u043F\u043E\u0437\u0436\u0435. \u0415\u0441\u043B\u0438 \u044D\u0442\u043E \u043D\u0435 \u043F\u043E\u043C\u043E\u0436\u0435\u0442, \u043E\u0442\u043F\u0440\u0430\u0432\u044C\u0442\u0435 \u0441\u043A\u0440\u0438\u043D\u0448\u043E\u0442 \u0438 \u0441\u0441\u044B\u043B\u043A\u0443 \u044D\u0442\u043E\u0439 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043D\u0430",
                ' ',
                react_1.default.createElement("a", { href: 'mailto:help@sravni.ru' }, "help@sravni.ru"),
                ". \u041A\u043E\u0434 \u043E\u0448\u0438\u0431\u043A\u0438 \u2014 500.",
                ' ',
                react_1.default.createElement("a", { onClick: onCopy },
                    "ID\u00A0",
                    id))),
        },
        404: {
            title: 'Здесь чего-то не хватает',
            description: (react_1.default.createElement(react_1.default.Fragment, null,
                "\u0427\u0430\u0441\u0442\u044C \u0441\u043E\u0434\u0435\u0440\u0436\u0438\u043C\u043E\u0433\u043E \u044D\u0442\u043E\u0439 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u0431\u043E\u043B\u044C\u0448\u0435 \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430 \u0434\u043B\u044F \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F. \u041A\u043E\u0434 \u043E\u0448\u0438\u0431\u043A\u0438 \u2014 404.",
                ' ',
                react_1.default.createElement("a", { onClick: onCopy },
                    "ID\u00A0",
                    id))),
        },
        400: {
            title: 'Похоже, что-то сломалось',
            description: (react_1.default.createElement(react_1.default.Fragment, null,
                "\u0427\u0442\u043E\u0431\u044B \u043C\u044B \u0441\u043A\u043E\u0440\u0435\u0435 \u043D\u0430\u0448\u043B\u0438 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0443 \u0438 \u0440\u0435\u0448\u0438\u043B\u0438 \u0435\u0451, \u043E\u0442\u043F\u0440\u0430\u0432\u044C\u0442\u0435 \u0441\u043A\u0440\u0438\u043D\u0448\u043E\u0442 \u0438 \u0441\u0441\u044B\u043B\u043A\u0443 \u044D\u0442\u043E\u0439 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043D\u0430",
                ' ',
                react_1.default.createElement("a", { href: 'mailto:help@sravni.ru' }, "help@sravni.ru"),
                ". \u041A\u043E\u0434 \u043E\u0448\u0438\u0431\u043A\u0438 \u2014 400.",
                ' ',
                react_1.default.createElement("a", { onClick: onCopy },
                    "ID\u00A0",
                    id))),
        },
        429: {
            title: 'Комментарий не отправлен',
            description: (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("b", null, "\u041D\u0435 \u0441\u043F\u0435\u0448\u0438\u0442\u0435!"),
                " \u041F\u0443\u0431\u043B\u0438\u043A\u043E\u0432\u0430\u0442\u044C \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F \u043C\u043E\u0436\u043D\u043E \u043D\u0435 \u0447\u0430\u0449\u0435, \u0447\u0435\u043C \u0440\u0430\u0437 \u0432 \u0434\u0432\u0435 \u043C\u0438\u043D\u0443\u0442\u044B!")),
        },
        401: {
            title: 'Требуется авторизация',
            description: (react_1.default.createElement(react_1.default.Fragment, null,
                "\u0427\u0442\u043E\u0431\u044B \u0432\u044B\u043F\u043E\u043B\u043D\u0438\u0442\u044C \u044D\u0442\u043E \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435, \u043D\u0443\u0436\u043D\u043E ",
                user ? 'заново войти' : 'войти',
                " \u0432 \u0441\u0432\u043E\u0439 \u043F\u0440\u043E\u0444\u0438\u043B\u044C \u043D\u0430 \u0441\u0430\u0439\u0442\u0435. \u041A\u043E\u0434 \u043E\u0448\u0438\u0431\u043A\u0438 \u2014 401. ",
                react_1.default.createElement("a", { onClick: onCopy },
                    "ID\u00A0",
                    id))),
        },
        403: {
            title: 'У вас недостаточно прав',
            description: (react_1.default.createElement(react_1.default.Fragment, null,
                "\u041F\u0435\u0440\u0435\u0437\u0430\u0439\u0434\u0438\u0442\u0435 \u0432 \u0441\u0432\u043E\u0439 \u043F\u0440\u043E\u0444\u0438\u043B\u044C \u0438 \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435. \u0415\u0441\u043B\u0438 \u044D\u0442\u043E \u043D\u0435 \u043F\u043E\u043C\u043E\u0436\u0435\u0442, \u043E\u0442\u043F\u0440\u0430\u0432\u044C\u0442\u0435 \u0441\u043A\u0440\u0438\u043D\u0448\u043E\u0442 \u0438 \u0441\u0441\u044B\u043B\u043A\u0443 \u044D\u0442\u043E\u0439 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043D\u0430 ",
                react_1.default.createElement("a", { href: 'mailto:help@sravni.ru' }, "help@sravni.ru"),
                ". \u041A\u043E\u0434 \u043E\u0448\u0438\u0431\u043A\u0438 \u2014 403.",
                ' ',
                react_1.default.createElement("a", { onClick: onCopy },
                    "ID\u00A0",
                    id))),
        },
        406: {
            title: 'Количество запросов ограничено',
            description: (react_1.default.createElement(react_1.default.Fragment, null, "\u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u043E\u0437\u0436\u0435. \u041A\u043E\u0434 \u043E\u0448\u0438\u0431\u043A\u0438 \u2014 406.")),
        },
    };
};
const dispatchErrorToast = ({ code, id, callback }) => {
    if (!code)
        return;
    const state = window['__NEXT_REDUX_STORE__'];
    const user = userSelector(state.getState());
    const handleCopyId = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        const { default: copy } = await Promise.resolve().then(() => __importStar(require('copy-to-clipboard')));
        copy(id);
    };
    const ERROR_MAP = getErrorMap(user, id, handleCopyId);
    if (code in ERROR_MAP) {
        callback(ERROR_MAP[code]);
    }
};
exports.dispatchErrorToast = dispatchErrorToast;
